exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.caseDescription textarea {\n    line-height: 20px !important;\n}\n.descriptionContainer .caseDescription {\n    padding-top: 0;\n    margin-top: 0;\n}\n", ""]);
